export default "__VITE_ASSET__C1dnP2ha__"